import * as React from "react";
import { Paragraph } from "@project-stories/elements/Paragraph/Paragraph";
import { Collapsible } from "@arctheme-components/elements/Collapsible/Collapsible";
import { Link } from "@arctheme-components/elements/Link/Link";
import useMobileBreakpoint from "@src/hooks/useMobileBreakpoint";

export const FooterLinks = ({ id, globals, shop, settings, list_links, type }) => {
  const isMobile = useMobileBreakpoint(settings.mobile_breakpoint);

  return (
    <div key={id} className={`footer-links-list`}>
      <Collapsible
        title={list_links.links_title}
        titleClass={`${isMobile ? "sh5" : "b1 font-normal"}`}
        contentClass={`${isMobile ? "b3" : "b2"}`}
        openIcon="icon-caret-down-thin"
        closeIcon="icon-caret-up-thin"
        desktopDisabled
      >
        <nav aria-label="Footer Menu">
          <ul aria-label="footer menu" role="menu">
            {list_links.links.map((link, id) => {
              return (
                <li key={id} role="menuitem">
                  <Link link={link.url}>
                      {link.title}
                  </Link>
                </li>
              );
            })}
          </ul>
        </nav>
      </Collapsible>
    </div>
  );
};
